// Small pieces the /welcome cards share: the red error line (TeamSyncErrorText), the icon bullet (TeamSyncBullet) and
// the muted footnote.

import type { ReactNode } from 'react';
import { IconBadge } from '@/ui';
import { cn } from '@/ui/cn';

/** An error under a section (role=alert so it is read out when it appears). */
export function ErrorNote({ children, id, className }: { children: ReactNode; id?: string; className?: string }) {
  return (
    <p id={id} role="alert" className={cn('rounded-control bg-danger-soft px-3 py-2 text-sm font-medium text-danger-text', className)}>
      {children}
    </p>
  );
}

/** A tinted icon with a line of explanation. */
export function Bullet({ icon, color, children }: { icon: ReactNode; color: string; children: ReactNode }) {
  return (
    <div className="flex items-start gap-3">
      <IconBadge icon={icon} color={color} size={28} />
      <p className="pt-1 text-[13px] leading-snug text-fg-muted">{children}</p>
    </div>
  );
}

export function Footnote({ children, id, className }: { children: ReactNode; id?: string; className?: string }) {
  return (
    <p id={id} className={cn('text-xs leading-snug text-fg-muted', className)}>
      {children}
    </p>
  );
}
